export const currencyId = {};
currencyId['234'] = 'USD';
currencyId['1'] = 'EUR';
currencyId['231'] = 'GBP';
currencyId['105'] = 'INR';
currencyId['13'] = 'AUD';
currencyId['38'] = 'CAD';
currencyId['2'] = 'AED';
currencyId['114'] = 'JPY';
currencyId['95'] = 'HKD';
currencyId['177'] = 'PHP';
currencyId['198'] = 'SGD';
currencyId['100'] = 'HUF';
currencyId['123'] = 'CHF';
currencyId['48'] = 'CNY';
currencyId['56'] = 'CZK';
currencyId['157'] = 'MXN';
currencyId['158'] = 'MYR';
currencyId['179'] = 'PLN';
currencyId['197'] = 'SEK';
currencyId['228'] = 'TWD';
currencyId['115'] = 'KES';
currencyId['193'] = 'SAR';

currencyId['47'] = 'XAF'; // Cameroon

// Africa
currencyId['62'] = 'DZD'; // Algeria
currencyId['21'] = 'XOF'; // Burkina Faso
currencyId['41'] = 'XAF'; // Central African Republic
currencyId['93'] = 'XOF'; // Guinea-Bissau
currencyId['142'] = 'MGA'; // Madagascar
currencyId['145'] = 'XOF'; // Mali
currencyId['248'] = 'EUR'; // Mayotte
currencyId['137'] = 'MAD'; // Morocco
currencyId['159'] = 'MZN'; // Mozambique
currencyId['160'] = 'NAD'; // Namibia
currencyId['162'] = 'XOF'; // Niger
currencyId['188'] = 'EUR'; // Reunion
currencyId['192'] = 'RWF'; // Rwanda
currencyId['205'] = 'XOF'; // Senegal
currencyId['229'] = 'TZS'; // Tanzania
currencyId['217'] = 'XOF'; // Togo
currencyId['223'] = 'TND'; // Tunisia

// Asia / Middle East
currencyId['183'] = 'ILS'; // Palestine

// Americas / Caribbean
currencyId['150'] = 'EUR'; // Martinique
currencyId['182'] = 'USD'; // Puerto Rico
currencyId['26'] = 'EUR'; // Saint Barthelemy
currencyId['141'] = 'EUR'; // Saint Martin (French part)
currencyId['180'] = 'EUR'; // Saint Pierre and Miquelon
currencyId['241'] = 'USD'; // U.S. Virgin Islands

// Oceania / Pacific
currencyId['11'] = 'USD'; // American Samoa
currencyId['54'] = 'AUD'; // Christmas Island
currencyId['92'] = 'USD'; // Guam
currencyId['171'] = 'NZD'; // New Zealand
currencyId['163'] = 'AUD'; // Norfolk Island
currencyId['149'] = 'USD'; // Northern Mariana Islands
currencyId['130'] = 'LKR'; // Sri Lanka

// currencyId['254'] = 'XAF';  // Republic of the Congo (id=254, code=CG — not in original data, added)
// currencyId['253'] = 'XOF';  // Côte d'Ivoire (id=253, code=CI — not in original data, added)
// const ENVIRONMENT = 'uat';
const ENVIRONMENT = 'production';
export const Constants = {
  BASE_URL:
    ENVIRONMENT == 'uat'
      ? 'https://fxmaster-prod-apim.azure-api.net/fxmaster-api-prod-clone1/'
      : 'https://fxmaster-prod-apim.azure-api.net/fxmaster-api-prod/v1/',
  SUBSCRIPTION_KEY:
    ENVIRONMENT == 'uat'
      ? 'd9ca05910ac147cd99d2578c2bd62f5c'
      : '83a68075ae6b41b88ee508722b29ed35',
  FXMASTER_BASE_URL:
    ENVIRONMENT == 'uat'
      ? 'https://uat.fxmaster.co.uk/'
      : 'https://adminfxmaster.com/',
  FILE_PATH_BASE_URL:
    ENVIRONMENT == 'uat'
      ? 'https://fxmaster1.blob.core.windows.net/fxmaster-uat/'
      : 'https://fxmaster1.blob.core.windows.net/fxmaster-prod/',
  REPORTS_BASE_URL:
    ENVIRONMENT == 'uat'
      ? 'https://uat-reports.fxmaster.co.uk/'
      : 'https://reports.fxmaster.co.uk/',
  REPORTS_USER_NAME:
    ENVIRONMENT == 'uat'
      ? 'shreyanshu@fxmaster.co.uk'
      : 'report@fxmaster.co.uk',
  REPORTS_PASSWORD: ENVIRONMENT == 'uat' ? 'Fxmaster@6713' : '7tKePDFs6HXzeb9',
  CURRENCYID: currencyId,
  MAINTENANCE: true,
  FCM_APIDKEY:
    ENVIRONMENT == 'uat'
      ? 'BAKmjye3HhrgMn1h6ui2kdFuTY7_cdDnWqSuzrf3dg3G0PRvpWCEzPwCe18iat7Jfh1TJ2jRdX8KQvcs9RH1Myc'
      : 'BAKmjye3HhrgMn1h6ui2kdFuTY7_cdDnWqSuzrf3dg3G0PRvpWCEzPwCe18iat7Jfh1TJ2jRdX8KQvcs9RH1Myc',
  TRANSACTION_STATUS: [
    'Settled',
    'submitted',
    'completed',
    'accepted',
    'Cancelled',
    'declined',
    'deleted',
    'failed',
    'pending',
    'ready_to_send',
    'rejected',
    'Returned',
    'Fees',
    'InvalidAccount',
    'Waiting For Funds'
  ],
  BULK_UPLOAD_TRANSACTION_STATUS: [
    'Settled',
    'Submitted',
    'Cancelled',
    'Failed',
    'Pending',
    'Rejected',
    'Returned',
  ],
  INR_INDIVIDUAL_REASONS: [
    {
      id: 1,
      code: 'PC01',
      description: 'Family',
      remitter_type: 'Individual',
      beneficiary_type: 'Individual',
      display_name: 'Personal',
    },
    {
      id: 3,
      code: 'PC02',
      description: 'Payments to families of Non-resident Indians.',
      remitter_type: 'Individual',
      beneficiary_type: 'Individual',
      display_name: 'Payment To friends',
    },
    {
      id: 4,
      code: 'PC03',
      description:
        'Payments in favour of Insurance companies, Mutual Funds and the Postmaster for premium /investments.',
      remitter_type: 'Individual',
      beneficiary_type: 'business',
      display_name: 'Insurance or Mutual Fund payments',
    },

    {
      id: 5,
      code: 'PC04',
      description:
        'Payments in favour of bankers for investments in shares, debentures',
      remitter_type: 'Individual',
      beneficiary_type: 'Individual',
      display_name: 'Payments for shares or investments',
    },
    {
      id: 6,
      code: 'PC05',
      description:
        'Payment to Coop. Housing Societies, Govt. Housing Schemes or Estate Developers for acquisition of residential flats in India in individual names subject to compliance of regulations thereof by the Non-\r\nresident Indians',
      remitter_type: 'Individual',
      beneficiary_type: 'Individual, business',
      display_name: 'Payment to housing schemes',
    },
    {
      id: 7,
      code: 'PC06',
      description:
        'Payments of tuition / boarding, examination fee etc. to schools, colleges and other educational\r\ninstitutions.',
      remitter_type: 'Individual',
      beneficiary_type: 'business',
      display_name: 'Payment for school/exam fees.',
    },
    {
      id: 8,
      code: 'PC07',
      description:
        'Payments to medical institutions and hospitals for medical treatment of NRIs / their dependents and\r\nnationals of Gulf Countries in India.',
      remitter_type: 'Individual',
      beneficiary_type: 'business',
      display_name: 'Payment for medical Treatment',
    },
    {
      id: 9,
      code: 'PC08',
      description:
        'Payments to hotels by nationals of Gulf countries / NRIs for their stay.',
      remitter_type: 'Individual',
      beneficiary_type: 'Individual, business',
      display_name: 'Payments for hotels or stay in india',
    },
    {
      id: 10,
      code: 'PC09',
      description:
        'Payments to travel agents for booking of passages of NRIs and their families residing in India towards their travel in India by domestic airlines / rail, etc.',
      remitter_type: 'Individual, business',
      beneficiary_type: 'Individual, business',
      display_name: 'Payment for travel bookings.',
    },
    {
      id: 11,
      code: 'PC11',
      description:
        'Payments to utility service providers in India, for services such as water supply, electricity supply, telephone (except for mobile top-ups), internet, television etc.',
      remitter_type: 'Individual',
      beneficiary_type: 'business',
      display_name: 'Electricity/Water bill Payments',
    },
    {
      id: 12,
      code: 'PC12',
      description: 'Tax payments in India',
      remitter_type: 'Individual',
      beneficiary_type: 'business',
      display_name: 'Tax Payments',
    },
    {
      id: 13,
      code: 'PC13',
      description:
        'EMI payments in India to Banks and Non-Banking Financial Companies (NBFCs) for repayment of loans',
      remitter_type: 'Individual',
      beneficiary_type: 'business',
      display_name: 'Payment For loans',
    },
    {
      id: 14,
      code: 'PC14',
      description:
        "Remittances to the Prime Minister's National Relief Fund subject to the condition that the remittances are directly credited to the Fund by the banks and the banks maintain full details of the remitters.",
      remitter_type: 'individual, business',
      beneficiary_type: 'business',
      display_name: 'National relief funds',
    },
  ],
  INR_BUSINESS_REASONS: [
    {
      id: 2,
      code: 'PC10',
      description:
        'PC10 Trade transactions up to Rs. 15 lakhs\r\nper transaction',
      remitter_type: 'business',
      beneficiary_type: 'individual, business',
      display_name: 'Invoice Payments',
    },
    {
      id: 10,
      code: 'PC09',
      description:
        'Payments to travel agents for booking of passages of NRIs and their families residing in India towards their travel in India by domestic airlines / rail, etc.',
      remitter_type: 'Individual, business',
      beneficiary_type: 'Individual, business',
      display_name: 'Payment for travel bookings.',
    },
    {
      id: 14,
      code: 'PC14',
      description:
        "Remittances to the Prime Minister's National Relief Fund subject to the condition that the remittances are directly credited to the Fund by the banks and the banks maintain full details of the remitters.",
      remitter_type: 'individual, business',
      beneficiary_type: 'business',
      display_name: 'National relief funds',
    },
    {
      id: 15,
      code: 'PC15',
      description: 'Salary Payment',
      remitter_type: 'business',
      beneficiary_type: 'Individual',
      display_name: 'Salary Payment.',
    },
    {
      id: 16,
      code: 'PC16',
      description: 'Trade transactions up to Rs. 15 lakhs per transaction',
      remitter_type: 'business',
      beneficiary_type: 'Individual, business',
      display_name: 'Trade Transactions upto 15 Lacs INR',
    },
  ],
  CURRENCY: ['INR'],
  ACCOUNT_DETAILS: [
    {
      GBP: [{ 'Account Number': '00000363', 'Sort Code': '040880' }],
      USD: [
        {
          'Payment Type': 'ACH Payment',
          'Account Number': '8333983531',
          'ACH Routing Number': '026073150',
        },
        {
          'Payment Type': 'Fedwire Payment',
          'Account Number': '8333983531',
          'Fedwire Routing Number': '026073008',
        },
        {
          'Payment Type': 'SWIFT Payment',
          IBAN: 'GB25TCCL04140411768452',
          BIC: 'TCCLGB3L',
        },
      ],
      CAD: [
        {
          'Payment Type': 'SWIFT Payment',
          IBAN: 'GB25TCCL04140411768452',
          BIC: 'TCCLGB3L',
        },
      ],
      MXN: [
        {
          'Payment Type': 'SWIFT Payment',
          IBAN: 'GB25TCCL04140411768452',
          BIC: 'TCCLGB3L',
        },
      ],
      AED: [
        {
          'Payment Type': 'SWIFT Payment',
          IBAN: 'GB25TCCL04140411768452',
          BIC: 'TCCLGB3L',
        },
      ],
      AUD: [
        {
          'Payment Type': 'SWIFT Payment',
          IBAN: 'GB25TCCL04140411768452',
          BIC: 'TCCLGB3L',
        },
      ],
      JPY: [
        {
          'Payment Type': 'SWIFT Payment',
          IBAN: 'GB25TCCL04140411768452',
          BIC: 'TCCLGB3L',
        },
      ],
      KES: [
        {
          'Payment Type': 'SWIFT Payment',
          IBAN: 'GB25TCCL04140411768452',
          BIC: 'TCCLGB3L',
        },
      ],
      HUF: [
        {
          'Payment Type': 'SWIFT Payment',
          IBAN: 'GB25TCCL04140411768452',
          BIC: 'TCCLGB3L',
        },
      ],
      CHF: [
        {
          'Payment Type': 'SWIFT Payment',
          IBAN: 'GB25TCCL04140411768452',
          BIC: 'TCCLGB3L',
        },
      ],
      KWD: [
        {
          'Payment Type': 'SWIFT Payment',
          IBAN: 'GB25TCCL04140411768452',
          BIC: 'TCCLGB3L',
        },
      ],
      HKD: [
        {
          'Payment Type': 'SWIFT Payment',
          IBAN: 'GB25TCCL04140411768452',
          BIC: 'TCCLGB3L',
        },
      ],
      SGD: [
        {
          'Payment Type': 'SWIFT Payment',
          IBAN: 'GB25TCCL04140411768452',
          BIC: 'TCCLGB3L',
        },
      ],
      INR: [{}],
      BGN: [
        {
          'Payment Type': 'SWIFT Payment',
          IBAN: 'GB25TCCL04140411768452',
          BIC: 'TCCLGB3L',
        },
      ],
      EUR: [
        {
          'Payment Type': 'SEPA Payment',
          IBAN: 'GB20TCCL00997939941755',
          BIC: 'TCCLGB31',
        },
        {
          'Payment Type': 'SWIFT Payment',
          IBAN: 'GB25TCCL04140411768452',
          BIC: 'TCCLGB3L',
        },
      ],
    },
  ],
  ACCOUNT_DETAILS_KEYS: [
    'Payment Type',
    'Account Number',
    'Sort Code',
    'ACH Routing Number',
    'Fedwire Routing Number',
    'IBAN',
    'BIC',
  ],
  INDIVIDUAL_CURRENCIES: [
    {
      id: 234,
      code: 'US',
      name: 'United States',
      native: 'United States',
      phone: '1',
      continent: 'NA',
      capital: 'Washington D.C.',
      currency: 'USD',
      languages: 'en',
      risk_score: '1',
    },
    {
      id: 231,
      code: 'GB',
      name: 'United Kingdom',
      native: 'British',
      phone: '44',
      continent: 'Europe',
      capital: 'London',
      currency: 'GBP',
      languages: 'en',
      risk_score: '1',
    },
    {
      id: 105,
      code: 'IN',
      name: 'India',
      native: 'भारत',
      phone: '91',
      continent: 'AS',
      capital: 'New Delhi',
      currency: 'INR',
      languages: 'hi,en',
      risk_score: '2',
    },
    {
      id: 13,
      code: 'AU',
      name: 'Australia',
      native: 'Australia',
      phone: '61',
      continent: 'OC',
      capital: 'Canberra',
      currency: 'AUD',
      languages: 'en',
      risk_score: '1',
    },
    {
      id: 38,
      code: 'CA',
      name: 'Canada',
      native: 'Canada',
      phone: '1',
      continent: 'NA',
      capital: 'Ottawa',
      currency: 'CAD',
      languages: 'en,fr',
      risk_score: null,
    },
    {
      id: 2,
      code: 'AE',
      name: 'United Arab Emirates',
      native: 'دولة الإمارات العربية المتحدة',
      phone: '971',
      continent: 'AS',
      capital: 'Abu Dhabi',
      currency: 'AED',
      languages: 'ar',
      risk_score: null,
    },
    {
      id: 114,
      code: 'JP',
      name: 'Japan',
      native: '日本',
      phone: '81',
      continent: 'AS',
      capital: 'Tokyo',
      currency: 'JPY',
      languages: 'ja',
      risk_score: null,
    },
    {
      id: 95,
      code: 'HK',
      name: 'Hong Kong',
      native: '香港',
      phone: '852',
      continent: 'AS',
      capital: 'City of Victoria',
      currency: 'HKD',
      languages: 'zh,en',
      risk_score: null,
    },
    {
      id: 177,
      code: 'PH',
      name: 'Philippines',
      native: 'Pilipinas',
      phone: '63',
      continent: 'AS',
      capital: 'Manila',
      currency: 'PHP',
      languages: 'en',
      risk_score: null,
    },
    {
      id: 198,
      code: 'SG',
      name: 'Singapore',
      native: 'Singapore',
      phone: '65',
      continent: 'AS',
      capital: 'Singapore',
      currency: 'SGD',
      languages: 'en,ms,ta,zh',
      risk_score: null,
    },
    {
      id: 100,
      code: 'HU',
      name: 'Hungary',
      native: 'Magyarország',
      phone: '36',
      continent: 'EU',
      capital: 'Budapest',
      currency: 'HUF',
      languages: 'hu',
      risk_score: null,
    },
    {
      id: 43,
      code: 'CH',
      name: 'Switzerland',
      native: 'Schweiz',
      phone: '41',
      continent: 'EU',
      capital: 'Bern',
      currency: 'CHF',
      languages: 'de,fr,it',
      risk_score: null,
    },
    {
      id: 48,
      code: 'CN',
      name: 'China',
      native: '中国',
      phone: '86',
      continent: 'AS',
      capital: 'Beijing',
      currency: 'CNY',
      languages: 'zh',
      risk_score: null,
    },
    {
      id: 56,
      code: 'CZ',
      name: 'Czech Republic',
      native: 'Česká republika',
      phone: '420',
      continent: 'EU',
      capital: 'Prague',
      currency: 'CZK',
      languages: 'cs,sk',
      risk_score: null,
    },
    {
      id: 157,
      code: 'MX',
      name: 'Mexico',
      native: 'México',
      phone: '52',
      continent: 'NA',
      capital: 'Mexico City',
      currency: 'MXN',
      languages: 'es',
      risk_score: null,
    },
    {
      id: 158,
      code: 'MY',
      name: 'Malaysia',
      native: 'Malaysia',
      phone: '60',
      continent: 'AS',
      capital: 'Kuala Lumpur',
      currency: 'MYR',
      languages: 'ms',
      risk_score: null,
    },
    {
      id: 179,
      code: 'PL',
      name: 'Poland',
      native: 'Polska',
      phone: '48',
      continent: 'EU',
      capital: 'Warsaw',
      currency: 'PLN',
      languages: 'pl',
      risk_score: null,
    },
    {
      id: 197,
      code: 'SE',
      name: 'Sweden',
      native: 'Sverige',
      phone: '46',
      continent: 'EU',
      capital: 'Stockholm',
      currency: 'SEK',
      languages: 'sv',
      risk_score: null,
    },
    {
      id: 228,
      code: 'TW',
      name: 'Taiwan',
      native: '臺灣',
      phone: '886',
      continent: 'AS',
      capital: 'Taipei',
      currency: 'TWD',
      languages: 'zh',
      risk_score: null,
    },
    {
      id: 115,
      code: 'KE',
      name: 'Kenya',
      native: 'Kenya',
      phone: '254',
      continent: 'AF',
      capital: 'Nairobi',
      currency: 'KES',
      languages: 'en,sw',
      risk_score: null,
    },
    {
      id: 193,
      code: 'SA',
      name: 'Saudi Arabia',
      native: 'المملكة العربية السعودية',
      phone: '966',
      continent: 'AS',
      capital: 'Riyadh',
      currency: 'SAR',
      languages: 'ar',
      risk_score: null,
    },
    {
      id: 47,
      code: 'CM',
      name: 'Cameroon',
      native: 'Cameroon',
      phone: '237',
      continent: 'AF',
      capital: 'Yaoundé',
      currency: 'XAF',
      languages: 'en,fr',
      risk_score: null,
    },
    {
      id: 62,
      code: 'DZ',
      name: 'Algeria',
      native: 'الجزائر',
      phone: '213',
      continent: 'AF',
      capital: 'Algiers',
      currency: 'DZD',
      languages: 'ar',
      risk_score: null,
    },
    {
      id: 21,
      code: 'BF',
      name: 'Burkina Faso',
      native: 'Burkina Faso',
      phone: '226',
      continent: 'AF',
      capital: 'Ouagadougou',
      currency: 'XOF',
      languages: 'fr,ff',
      risk_score: null,
    },
    {
      id: 41,
      code: 'CF',
      name: 'Central African Republic',
      native: 'Ködörösêse tî Bêafrîka',
      phone: '236',
      continent: 'AF',
      capital: 'Bangui',
      currency: 'XAF',
      languages: 'fr,sg',
      risk_score: null,
    },
    {
      id: 93,
      code: 'GW',
      name: 'Guinea-Bissau',
      native: 'Guiné-Bissau',
      phone: '245',
      continent: 'AF',
      capital: 'Bissau',
      currency: 'XOF',
      languages: 'pt',
      risk_score: null,
    },
    {
      id: 142,
      code: 'MG',
      name: 'Madagascar',
      native: 'Madagasikara',
      phone: '261',
      continent: 'AF',
      capital: 'Antananarivo',
      currency: 'MGA',
      languages: 'fr,mg',
      risk_score: null,
    },
    {
      id: 145,
      code: 'ML',
      name: 'Mali',
      native: 'Mali',
      phone: '223',
      continent: 'AF',
      capital: 'Bamako',
      currency: 'XOF',
      languages: 'fr',
      risk_score: null,
    },
    {
      id: 248,
      code: 'YT',
      name: 'Mayotte',
      native: 'Mayotte',
      phone: '262',
      continent: 'AF',
      capital: 'Mamoudzou',
      currency: 'EUR',
      languages: 'fr',
      risk_score: null,
    },
    {
      id: 137,
      code: 'MA',
      name: 'Morocco',
      native: 'المغرب',
      phone: '212',
      continent: 'AF',
      capital: 'Rabat',
      currency: 'MAD',
      languages: 'ar',
      risk_score: null,
    },
    {
      id: 159,
      code: 'MZ',
      name: 'Mozambique',
      native: 'Moçambique',
      phone: '258',
      continent: 'AF',
      capital: 'Maputo',
      currency: 'MZN',
      languages: 'pt',
      risk_score: null,
    },
    {
      id: 160,
      code: 'NA',
      name: 'Namibia',
      native: 'Namibia',
      phone: '264',
      continent: 'AF',
      capital: 'Windhoek',
      currency: 'NAD',
      languages: 'en,af',
      risk_score: null,
    },
    {
      id: 162,
      code: 'NE',
      name: 'Niger',
      native: 'Niger',
      phone: '227',
      continent: 'AF',
      capital: 'Niamey',
      currency: 'XOF',
      languages: 'fr',
      risk_score: null,
    },
    {
      id: 188,
      code: 'RE',
      name: 'Reunion',
      native: 'La Réunion',
      phone: '262',
      continent: 'AF',
      capital: 'Saint-Denis',
      currency: 'EUR',
      languages: 'fr',
      risk_score: null,
    },
    {
      id: 192,
      code: 'RW',
      name: 'Rwanda',
      native: 'Rwanda',
      phone: '250',
      continent: 'AF',
      capital: 'Kigali',
      currency: 'RWF',
      languages: 'rw,en,fr',
      risk_score: null,
    },
    {
      id: 205,
      code: 'SN',
      name: 'Senegal',
      native: 'Sénégal',
      phone: '221',
      continent: 'AF',
      capital: 'Dakar',
      currency: 'XOF',
      languages: 'fr',
      risk_score: null,
    },
    {
      id: 229,
      code: 'TZ',
      name: 'Tanzania',
      native: 'Tanzania',
      phone: '255',
      continent: 'AF',
      capital: 'Dodoma',
      currency: 'TZS',
      languages: 'sw,en',
      risk_score: null,
    },
    {
      id: 217,
      code: 'TG',
      name: 'Togo',
      native: 'Togo',
      phone: '228',
      continent: 'AF',
      capital: 'Lomé',
      currency: 'XOF',
      languages: 'fr',
      risk_score: null,
    },
    {
      id: 223,
      code: 'TN',
      name: 'Tunisia',
      native: 'تونس',
      phone: '216',
      continent: 'AF',
      capital: 'Tunis',
      currency: 'TND',
      languages: 'ar',
      risk_score: null,
    },
    {
      id: 183,
      code: 'PS',
      name: 'Palestine',
      native: 'فلسطين',
      phone: '970',
      continent: 'AS',
      capital: 'Ramallah',
      currency: 'ILS',
      languages: 'ar',
      risk_score: null,
    },
    {
      id: 150,
      code: 'MQ',
      name: 'Martinique',
      native: 'Martinique',
      phone: '596',
      continent: 'NA',
      capital: 'Fort-de-France',
      currency: 'EUR',
      languages: 'fr',
      risk_score: null,
    },
    {
      id: 182,
      code: 'PR',
      name: 'Puerto Rico',
      native: 'Puerto Rico',
      phone: '1787',
      continent: 'NA',
      capital: 'San Juan',
      currency: 'USD',
      languages: 'es,en',
      risk_score: null,
    },
    {
      id: 26,
      code: 'BL',
      name: 'Saint Barthelemy',
      native: 'Saint-Barthélemy',
      phone: '590',
      continent: 'NA',
      capital: 'Gustavia',
      currency: 'EUR',
      languages: 'fr',
      risk_score: null,
    },
    {
      id: 141,
      code: 'MF',
      name: 'Saint Martin',
      native: 'Saint-Martin',
      phone: '590',
      continent: 'NA',
      capital: 'Marigot',
      currency: 'EUR',
      languages: 'en,fr,nl',
      risk_score: null,
    },
    {
      id: 180,
      code: 'PM',
      name: 'Saint Pierre and Miquelon',
      native: 'Saint-Pierre-et-Miquelon',
      phone: '508',
      continent: 'NA',
      capital: 'Saint-Pierre',
      currency: 'EUR',
      languages: 'fr',
      risk_score: null,
    },
    {
      id: 241,
      code: 'VI',
      name: 'U.S. Virgin Islands',
      native: 'United States Virgin Islands',
      phone: '1340',
      continent: 'NA',
      capital: 'Charlotte Amalie',
      currency: 'USD',
      languages: 'en',
      risk_score: null,
    },
    {
      id: 11,
      code: 'AS',
      name: 'American Samoa',
      native: 'American Samoa',
      phone: '1684',
      continent: 'OC',
      capital: 'Pago Pago',
      currency: 'USD',
      languages: 'en,sm',
      risk_score: null,
    },
    {
      id: 54,
      code: 'CX',
      name: 'Christmas Island',
      native: 'Christmas Island',
      phone: '61',
      continent: 'AS',
      capital: 'Flying Fish Cove',
      currency: 'AUD',
      languages: 'en',
      risk_score: null,
    },
    {
      id: 92,
      code: 'GU',
      name: 'Guam',
      native: 'Guam',
      phone: '1671',
      continent: 'OC',
      capital: 'Hagåtña',
      currency: 'USD',
      languages: 'en,ch,es',
      risk_score: null,
    },
    {
      id: 171,
      code: 'NZ',
      name: 'New Zealand',
      native: 'New Zealand',
      phone: '64',
      continent: 'OC',
      capital: 'Wellington',
      currency: 'NZD',
      languages: 'en,mi',
      risk_score: null,
    },
    {
      id: 163,
      code: 'NF',
      name: 'Norfolk Island',
      native: 'Norfolk Island',
      phone: '672',
      continent: 'OC',
      capital: 'Kingston',
      currency: 'AUD',
      languages: 'en',
      risk_score: null,
    },
    {
      id: 149,
      code: 'MP',
      name: 'Northern Mariana Islands',
      native: 'Northern Mariana Islands',
      phone: '1670',
      continent: 'OC',
      capital: 'Saipan',
      currency: 'USD',
      languages: 'en,ch',
      risk_score: null,
    },
  ],
  INDIVIDUAL_BALANCES_CURRENCIES: [
    {
      id: 1,
      currency: 'GBP',
      balance: 0,
      meta: {
        code: 'UK',
        name: 'United Kingdom',
        country_id: 231,
        flag: 'https://uat.dhigna.com/flags/UK.PNG',
      },
      created_at: '2025-06-28T08:23:31.170885Z',
      updated_at: '2025-06-28T08:23:31.170895Z',
    },
    {
      id: 3,
      currency: 'INR',
      balance: 0,
      meta: {
        code: 'IN',
        name: 'India',
        country_id: 105,
        flag: 'https://uat.dhigna.com/flags/IN.PNG',
      },
      created_at: '2025-06-28T08:23:31.170932Z',
      updated_at: '2025-06-28T08:23:31.170935Z',
    },
  ],
  STAFF_LOGIN_ID_CONVERSION: ['580', '524'],
  OTP_VERIFICATION :'456963',
  USD_ACCOUNT_DETAILS_SHOWN_WORKSPACES: ['1118'],
  CONVERA_SWIFT_FXMASTER: 'FFC/FMLTGB22XXX',
  CONVERA_SWIFT: 'TGBPUS3WXXX',
  CONVERA_ADDRESS: '7979 EAST TUFFS AVENUE, DENVER, United States',
  GOOGLE_MAPS_API_KEY: 'AIzaSyAGfdbaAW-2m4SgehbGuLTRtjWFECf9pXw',
};
